<template>
  <div id="map" style="height: 100%;">
    <v-dialog v-model="dialog" width="1200">
      <v-card class="fill-height" tile>
        <v-card-title>
          Informações
          <v-spacer />
          <v-btn icon @click="dialog = !dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs v-model="tab"
          background-color="primary"
          dark>
          <v-tab v-for="item in items()"
            :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items()"
            :key="item.tab">
            <v-card flat>
              <v-card-text>
                <v-data-table :headers="item.content.headers" :items="item.content.items" :loading="loading" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as L from 'leaflet'
import wms from 'leaflet.wms'

import { createBaseLayers, createLegend } from '@/domain/library'
import { createMeasure } from '@/domain/library'

//import { mousePosition } from '@/domain/library'

// Custom Controls
import { homeExtent } from '@/domain/library'
import { getBounds } from '@/domain/library'
import { coordinates } from '@/domain/library'

export default {
  name: 'Mapa',
  data: () => ({
    loading: false,
    dialog: false,
    tab: null,
    templates: [
      {
        layer: 'monitoramento_ferrugem_soja_pto_p4674', 
        tab: 'Alerta Ferrugem - Safra 2023/2024', 
        content: {
          headers: [
            { text: 'Município', value: 'municipio' },
            { text: 'Região', value: 'regiao' },
            { text: 'Messoregião', value: 'mesorregiao' },
            { text: 'Cultivar', value: 'cultivar' },
            { text: 'Data plantio', value: 'dtplantio' },
            { text: 'Data Primeiros Esporos', value: 'dtpriespo' },
            { text: 'Estágio Fenológico', value: 'estfeno' },
            { text: 'Situação', value: 'situacao' }	
          ],
          items: []
        } 
      },
      {
        layer: 'regioes_idr_pol_p4326', 
        tab: 'Regiões IDR-Paraná', 
        content: {
          headers: [
            { text: 'Região IDR',      value: 'regidr'  },
            { text: 'Mesorregião IDR', value: 'mesoidr'}
          ],
          items: []
        }
      }
    ]
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
 
  mounted () {
    this.$nextTick(() => {
      this.map = L.map('map', {
        zoomControl: false,
        minZoom: 5
      })

      this.atualizarTituloFerrugem();

      this.map.fitBounds(getBounds())
      this.map.setMaxBounds(getBounds())

      L.control.zoom({
        zoomInTitle: 'Aproximar',
        zoomOutTitle: 'Afastar'
      }).addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.scale({
        imperial: false
      }).addTo(this.map)

      // https://stackoverflow.com/questions/54441260/how-to-prevent-leaflet-map-resizing-on-zoom-in-vue-vuetify-app
      L.Control.include({
        _refocusOnMap: L.Util.falseFn // Do nothing.
      })

      this.$store.commit('setMap', this.map)     
      var baseLayers = createBaseLayers(this.map)

      var Source = wms.Source.extend({
        parseFeatureInfo: function (result) { // url
          var json = JSON.parse(result)
          return json.features
        },
        showFeatureInfo: (latlng, info) => {
          if(info.length != 0) {
            var showDialog = false
            for(const temp of this.templates) {
              temp.content.items = []
            }
            for(const feature of info) {
              for(const temp of this.templates) {
                if(feature.id.startsWith(temp.layer)) {
                  showDialog = true
                  temp.content.items.push(feature.properties)
                }
              }
            }
            if(showDialog) {
              this.dialog = true
            }
          }
        }
      })

      this.source = new Source(process.env.VUE_APP_GEOSERVER, {
        format: 'image/png',
        info_format: 'application/json',
        transparent: true,
        tiled: true,
        feature_count: 500
      })

      this.groupedOverlays = {
      'Dados Paraná': {
        'Municípios do Paraná':     this.source.getLayer('itcg:municipios_pol_p31982_e50'),
        'Regiões IDR-Paraná'  :    this.source.getLayer('emater:regioes_idr_pol_p4326')  
      },
      'IDR/Paraná': {
        //'Ferrugem Asiática':      this.source.getLayer('emater:monitoramento_ferrugem_soja_pto_p31982')
        'Alerta Ferrugem - Safra 2023/2024':        this.source.getLayer('emater:monitoramento_ferrugem_soja_pto_p4674')
      }
    } 
      L.control.groupedLayers(baseLayers, this.groupedOverlays, {
        collapsed: (this.$vuetify.breakpoint.width < 640 && this.$vuetify.breakpoint.height < 960) //se a tela for pequena deixa em icone o quadro
      }).addTo(this.map)

      if (this.groupedOverlays['IDR/Paraná']) {
        var overlay = this.groupedOverlays['Dados Paraná']['Municípios do Paraná']
        //overlay = this.groupedOverlays['IDR/Paraná']['Fontes']
        if (overlay) {
          overlay.addTo(this.map)
        }
        overlay = this.groupedOverlays['IDR/Paraná']['Alerta Ferrugem - Safra 2023/2024']
        if (overlay) {
          overlay.addTo(this.map)
        }
      }

      try {
        homeExtent().addTo(this.map)
      } catch (e) {
        console.log(e)
      }
      
      //mousePosition(this.map) // Posição do Mouse
      createMeasure(this.map) // Medir Distância
      createLegend(this.map)
      coordinates(this.map, false)

    })
  },
  methods: {
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    },
    atualizarTituloFerrugem () {
      this.$emit('atualizarTitulo', 'ferrugem');    
      },

    items () {
      var items = []
      for(const temp of this.templates) {
        if(temp.content.items.length != 0) {
          items.push(temp)
        }
      }
      return items
    }
  }
}
</script>
